import { Component, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { GeneralService } from "../services/general.service";
import { Router } from "@angular/router";
declare var $: any;
@Component({
  selector: "app-categorie",
  templateUrl: "./categorie.component.html",
  styleUrls: ["./categorie.component.scss"],
})
export class CategorieComponent implements OnInit {
  constructor(private router: Router, private generalService: GeneralService) { }
  dataSource = new MatTableDataSource([]);
  categories = [];
  categorieSelected: any;
  categorieSelected2: string = null;
  row = null;
  allCategories = [];
  disabled = false;
  isSaving = false;
  categorie;
  param_code; //existe dans html à vérifier 17/05/2019
  enregistrementTerminer: boolean = false;
  displayedColumns: Array<string> = [
    "categorie_Code",
    "categorie_Text",
    "categorie_Order",
    "categorie_Active",
    "categorie_Image",
    "categorie_Footer_Active",
    "SuppremerImage",
  ];
  initDoc;
  imageCategorie;
  //il contien tous les ds des image categorie;
  imageCategorieForUpdateIsLodet: boolean = false;
  isAllCategoriesIsLoated: boolean = false;
  useDataBaseToSaveImage;
  ngOnInit() {
    if (this.generalService.userConnecter == "") {
      this.router.navigate([""]);
    } else {
      this.useDataBaseToSaveImage = this.generalService.useDataBaseToSaveImage;
      this.getInitDoc();
      this.getAllCategorie();
      this.getImageCategorie();
    }
  }
  supprimerImage(item) {
    console.log(item);
    this.generalService
      .rechercheTable("ds/formdata?code=ecartcat&val=" + item.categorie_Code)
      .subscribe(
        (res) => {
          item.categorie_Image = null;
          res.ecArtCat[0].categorie_Image = null;
          this.generalService.enregisterTable(res).subscribe(
            (data) => {
              this.allCategories = this.allCategories.map((cat) => {
                if (cat.categorie_Code == item.categorie_Code) {
                  return { ...cat, categorie_Image: null };
                } else {
                  return cat;
                }
              });
              console.log(this.allCategories);

              this.generalService.dialogSuccess(
                "Suppression avec succés",
                true
              );
            },
            (err) => {
              this.generalService.dialogSuccess("Non enregistrer", false);
            }
          );
        },
        () => {
          this.generalService.dialogSuccess("Non enregistrer", false);
        }
      );
  }
  getAllCategorie() {
    this.generalService
      .rechercheTable(this.generalService.urlListeCategorie)
      .subscribe((data) => {
        this.allCategories = data;
        for (var i = 0; i < this.allCategories.length; i++) {
          this.allCategories[i]["File_Content_280_580_1"] = "assets/icon.png";
          this.allCategories[i]["File_Content_1450_700_1"] = "assets/icon.png";
          this.allCategories[i]["File_Content_1300_500_1"] = "assets/icon.png";
          this.allCategories[i]["File_Content_580_580_1"] = "assets/icon.png";
        }
        this.isAllCategoriesIsLoated = true;
        if (this.imageCategorieForUpdateIsLodet) {
          this.fillImageCategorieIn();
          this.enregistrementTerminer = true;
        }

        this.categories = this.generalService.clone(data);
      });
  }
  modePdf;
  openFrm(param) {
    this.modePdf = param;
    document.getElementById("input_file").click();
  }
  ds;
  selectionnerImage() { }
  ajouter(File) {
    this.enregistrementTerminer = false;
    this.generalService
      .rechercheTable("ds/formdata?code=ecartcat&val=")
      .subscribe((art) => {
        console.log(art);
        this.ds = art;
        var doc = this.generalService.clone(this.initDoc);
        doc.files[0].File_Parent = "";
        doc.files[0].File_Text = File.name;
        // doc.files[0].File_Key = this.lastItemSelected + "_Img"
        doc.files[0].File_Type = "ecImg";
        doc.files[0].File_Groupe = "";
        doc.files[0].File_Lien = "";
        doc.files[0].File_Class = "";
        this.generalService.uploadFile2(File, File.name).subscribe((data1) => {
          doc.files[0].File_Content = data1["fileName"];
          this.generalService.enregisterTable(doc).subscribe(
            (data) => {
              console.log("****** 1 ");

              this.generalService.dialogSuccess("image enregisté", true);
              this.enregistrementTerminer = true;
              console.log("****** scess ");
            },
            (err) => {
              console.log("****** err ");

              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("image  non enregisté", false);
            }
          );
        });
      });
  }

  categorieFooter;
  enregistrementTerminerImg = true;
  oncategorieModelValuechange(e) {
    // console.log(e);

    if (this.categorieSelected != undefined)
      this.categorieSelected2 = this.categorieSelected;
    var myList = this.allCategories;
    var list = myList.filter((val) => {
      if (val.categorie_Text)
        return (
          val.categorie_Text
            .toLowerCase()
            .indexOf(e.target.value.toLowerCase()) >= 0
        );
    });
    if (list.length == 0) {
      list = myList;
      e.target.value = e.target.value.substr(0, e.target.value.length - 1);
    }
    if (list.length == 1) {
      this.categorieModelSelected({
        option: { value: { categorie_Code: list[0].categorie_Code } },
      });
    } else {
      if (e.target.value == "")
        this.categorieModelSelected({
          option: { value: { categorie_Code: null } },
        });
      else this.dataSource = new MatTableDataSource();
    }
    this.categories = list;
  }
  mainCat;
  getCat(id, code) {
    this.enregistrementTerminer = false;
    this.generalService
      .rechercheTable("ds/formdata?code=ecartcat&val=" + id)
      .subscribe(
        (res: any) => {
          this.enregistrementTerminer = true;
          this.mainCat = res;
          this.lastItemSelected = code.option.value.categorie_Code;
          this.footerStatuts =
            res.ecArtCat[0].categorie_StatutFooter.toString();
          this.Statuts = res.ecArtCat[0].categorie_Statut.toString();
          this.setCategorie_Description = res.ecArtCat[0].categorie_Description;
          console.log(this.footerStatuts);
        },
        () => {
          this.generalService.dialogSuccess("Probleme de connexion", false);
          this.enregistrementTerminer = true;
        }
      );
  }
  // lastItemSelected
  categorieModelSelected(event) {
    // Use event.value if it's from a mat-select or similar, 
    // or event.option.value if it's from a mat-autocomplete
    const selectedCode = event.option ? event.option.value.categorie_Code : event.value.categorie_Code;

    if (selectedCode != null) {
      // 1. Filter sub-categories for the table
      var data = this.allCategories.filter((cat) => {
        return cat.categorie_CodeP == selectedCode;
      });

      // 2. Fetch details for the selected category itself
      this.getCat(selectedCode, event);

      // 3. Update the table datasource
      this.dataSource = new MatTableDataSource(data);
    } else {
      // Reset if no category selected
      var data = this.allCategories.filter((cat) => {
        return cat.categorie_CodeP == null || cat.categorie_CodeP == "";
      });
      this.dataSource = new MatTableDataSource(data);
    }
    console.log("Table updated with:", data);
  }
  // updateFooter() {
  //   console.log(this.categorieFooter);

  //   this.enregistrementTerminer = false;
  //   this.generalService.rechercheTable('ds/formdata?code=ecartcat&val=' + this.lastItemSelected).subscribe((res: any) => {
  //     console.log(res);
  //     res.ecArtCat[0].categorie_StatutFooter = this.categorieFooter
  //     this.generalService.enregisterTable(res).subscribe(resp => {
  //       console.log(resp);
  //       this.generalService.dialogSuccess("Enregistrer avec succés", true);
  //     }, () => {
  //       this.generalService.dialogSuccess("Probleme de connexion", false);
  //       this.enregistrementTerminer = true;
  //     })
  //     this.enregistrementTerminer = true;
  //   }, () => {
  //     this.generalService.dialogSuccess("Probleme de connexion", false);
  //     this.enregistrementTerminer = true;
  //   });
  // }
  fillImageCategorieIn() {
    this.allCategories.forEach((cat) => {
      var image_280_580 = this.imageCategorie.find((img) => {
        return img.File_Key == cat.categorie_Code + "_280_580_1";
      });
      var image_1450_700 = this.imageCategorie.find((img) => {
        return img.File_Key == cat.categorie_Code + "_1450_700_1";
      });
      var image_1300_500 = this.imageCategorie.find((img) => {
        return img.File_Key == cat.categorie_Code + "_1300_500_1";
      });
      var image_580_580 = this.imageCategorie.find((img) => {
        return img.File_Key == cat.categorie_Code + "_580_580_1";
      });
      if (image_280_580 != undefined)
        cat.File_Content_280_580_1 = image_280_580.File_Content;
      if (image_1450_700 != undefined)
        cat.File_Content_1450_700_1 = image_1450_700.File_Content;
      if (image_1300_500 != undefined)
        cat.File_Content_1300_500_1 = image_1300_500.File_Content;
      if (image_580_580 != undefined)
        cat.File_Content_580_580_1 = image_580_580.File_Content;
    });
  }
  afficher() {
    if (this.categorieSelected2 != null && this.categorieSelected2 != "")
      this.oncategorieModelValuechange({
        target: { value: this.categorieSelected2 },
      });
    else
      this.categorieModelSelected({
        option: { value: { categorie_Code: null } },
      });
  }
  onBlur(row, setCategorie_Statut: boolean) {
    if (setCategorie_Statut) row.categorie_Statut = !row.categorie_Statut;
    this.enregistrementTerminer = false;
    this.generalService
      .rechercheTable(
        this.generalService.urlcategorie + "&val=" + row.categorie_Code
      )
      .subscribe(
        (cat) => {
          cat.ecArtCat[0].categorie_Order = row.categorie_Order;
          if (row.categorie_Statut) cat.ecArtCat[0].categorie_Statut = 1;
          else cat.ecArtCat[0].categorie_Statut = 0;
          this.generalService.enregisterTable(cat).subscribe(
            (d) => {
              this.generalService.dialogSuccess("Enregister", true);
              this.enregistrementTerminer = true;
            },
            (err) => {
              this.generalService.dialogSuccess("Non enregister", false);
              this.enregistrementTerminer = true;
            }
          );
        },
        () => {
          this.generalService.dialogSuccess("Non enregistrer", false);
          this.enregistrementTerminer = true;
        }
      );
  }
  onBlurFooter(row, setCategorie_Statut) {
    console.log(setCategorie_Statut);

    if (setCategorie_Statut == 1) {
      row.categorie_StatutFooter = 0;
      setCategorie_Statut = 0;
    } else {
      row.categorie_StatutFooter = 1;
      setCategorie_Statut = 1;
    }

    console.log(setCategorie_Statut);
    this.enregistrementTerminer = false;
    this.generalService
      .rechercheTable(
        this.generalService.urlcategorie + "&val=" + row.categorie_Code
      )
      .subscribe(
        (cat) => {
          cat.ecArtCat[0].categorie_Order = row.categorie_Order;
          cat.ecArtCat[0].categorie_StatutFooter = setCategorie_Statut;
          this.generalService.enregisterTable(cat).subscribe(
            (d) => {
              this.generalService.dialogSuccess("Enregister", true);
              this.enregistrementTerminer = true;
            },
            (err) => {
              this.generalService.dialogSuccess("Non enregister", false);
              this.enregistrementTerminer = true;
            }
          );
        },
        () => {
          this.generalService.dialogSuccess("Non enregistrer", false);
          this.enregistrementTerminer = true;
        }
      );
  }
  footerStatuts;
  lastItemSelected;
  onBlurMainCat(setCategorie_Statut) {
    if (setCategorie_Statut == 1) this.footerStatuts = 0;
    else this.footerStatuts = 1;
    this.enregistrementTerminer = false;
    this.generalService
      .rechercheTable(
        this.generalService.urlcategorie + "&val=" + this.lastItemSelected
      )
      .subscribe(
        (cat: any) => {
          console.log(setCategorie_Statut);
          cat.ecArtCat[0].categorie_StatutFooter = setCategorie_Statut;

          this.generalService.enregisterTable(cat).subscribe(
            (d) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Enregister", true);
            },
            (err) => {
              this.generalService.dialogSuccess("Non enregister", false);
              this.enregistrementTerminer = true;
            }
          );
        },
        () => {
          this.generalService.dialogSuccess("Non enregistrer", false);
          this.enregistrementTerminer = true;
        }
      );
  }
  Statuts;
  setCategorie_Description;
  SaveDescription() {
    this.generalService
      .rechercheTable(
        this.generalService.urlcategorie + "&val=" + this.lastItemSelected
      )
      .subscribe(
        (cat: any) => {
          cat.ecArtCat[0].categorie_Description = this.setCategorie_Description;

          this.generalService.enregisterTable(cat).subscribe(
            (d) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Enregister", true);
            },
            (err) => {
              this.generalService.dialogSuccess("Non enregister", false);
              this.enregistrementTerminer = true;
            }
          );
        },
        () => {
          this.generalService.dialogSuccess("Non enregistrer", false);
          this.enregistrementTerminer = true;
        }
      );
  }
  onBlurStatuts(setCategorie_Statut) {
    if (setCategorie_Statut == 1) this.Statuts = 0;
    else this.Statuts = 1;
    this.enregistrementTerminer = false;
    this.generalService
      .rechercheTable(
        this.generalService.urlcategorie + "&val=" + this.lastItemSelected
      )
      .subscribe(
        (cat: any) => {
          console.log(setCategorie_Statut);
          cat.ecArtCat[0].categorie_Statut = setCategorie_Statut;

          this.generalService.enregisterTable(cat).subscribe(
            (d) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Enregister", true);
            },
            (err) => {
              this.generalService.dialogSuccess("Non enregister", false);
              this.enregistrementTerminer = true;
            }
          );
        },
        () => {
          this.generalService.dialogSuccess("Non enregistrer", false);
          this.enregistrementTerminer = true;
        }
      );
  }
  selectRow(event, row) {
    var els = document.getElementsByClassName("mat-row");
    Array.prototype.forEach.call(els, function (el) {
      el.style = "";
    });
    event.currentTarget.style = "background-color: #a0bdf3;";
    this.row = row;
  }

  setTextInput(cat) {
    if (cat) {
      return cat.categorie_Text;
    }
  }
  importer(id) {
    document.getElementById(id).click();
  }
  getInitDoc() {
    this.generalService.rechercheTable(this.generalService.urlAvtDoc).subscribe(
      (doc) => {
        this.initDoc = doc;
      },
      (e) => {
        this.enregistrementTerminer = true;
      }
    );
  }
  onChangeImagefile(fileInput, categorie_Code, width, height) {
    var reader2 = new FileReader();
    var src;
    reader2.onload = (e) => {
      src = reader2.result;
      var imagee = document.getElementById(
        width + "_" + height + categorie_Code
      );
      this.setNewImageInAllCategories(categorie_Code, src);
      imagee.setAttribute("src", src);
      var image = new Image();
      image.src = reader2.result.toString();
      image.onload = () => {
        this.saveImageCategorie(
          image,
          fileInput,
          categorie_Code,
          width,
          height
        );
      };
    };
    if (fileInput.target.files.length == 0) {
      var image = document.getElementById(
        width + "_" + height + categorie_Code
      );
      $("#" + width + "_" + height + categorie_Code).val("");
      image.setAttribute("src", "assets/icon.png");
    } else {
      reader2.readAsDataURL(fileInput.target.files[0]);
    }
  }
  setNewImageInAllCategories(categorie_Code, src) {
    var findCategorie = this.allCategories.find((categorie) => {
      return categorie.categorie_Code == categorie_Code;
    });
    if (findCategorie != undefined) {
      findCategorie.File_Content = src;
    }
  }
  addFiles(
    File_Content,
    File,
    File_Key,
    File_Type,
    File_Parent,
    clickMode,
    File_Groupe,
    File_Lien
  ) {
    var File_Text = File.name;
    var doc = this.generalService.clone(this.initDoc);
    if (clickMode != "renommer") {
      doc.files[0].File_Parent = File_Parent;
      doc.files[0].File_Text = File_Text;
      doc.files[0].File_Key = File_Key;
      doc.files[0].File_Type = File_Type;
      doc.files[0].File_Groupe = File_Groupe;
      doc.files[0].File_Lien = File_Lien;
      if (this.generalService.useDataBaseToSaveImage == 1) {
        doc.files[0].File_Content = File_Content;
        this.generalService.enregisterTable(doc).subscribe(
          (data) => {
            // this.generalService.dialogSuccess("iamge enregisté", true);
          },
          (err) => {
            this.enregistrementTerminer = true;
            this.generalService.dialogSuccess("image  non enregisté", false);
          }
        );
      }
      if (this.generalService.useDataBaseToSaveImage == 0) {
        // File_Content=this.extractContentBetweenQuotes(File_Content.toString())
        // var blob = dataURLToBlob(File);
        console.log(File);

        this.generalService.uploadFile2(File, File_Text).subscribe((data1) => {
          doc.files[0].File_Content = data1["fileName"];
          this.generalService.enregisterTable(doc).subscribe(
            (data) => {
              console.log("****** 1 ");

              this.generalService
                .rechercheTable(
                  "ds/formdata?code=ecartcat&val=" + doc.files[0].File_Key
                )
                .subscribe(
                  (art: any) => {
                    art.ecArtCat[0].categorie_Image = doc.files[0].File_Content;
                    this.generalService.enregisterTable(art).subscribe(
                      (update) => {
                        this.generalService.dialogSuccess(
                          "image enregisté",
                          true
                        );
                      },
                      (err) => {
                        this.generalService.dialogSuccess(
                          "image non enregisté ",
                          false
                        );
                      }
                    );
                  },
                  (err) => {
                    this.generalService.dialogSuccess(
                      "image non enregisté ",
                      false
                    );
                  }
                );
              console.log("****** scess ");
            },
            (err) => {
              console.log("****** err ");

              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("image non enregisté", false);
            }
          );
        });
      }
    }
  }
  base_url = this.generalService.base_url;
  async saveImageCategorie(image, fileInput, categorie_Code, width, height) {
    this.enregistrementTerminer = false;
    var imageToSave = this.imageCategorie.find((img) => {
      return img.File_Key == categorie_Code + "_" + width + "_" + height + "_1";
    });
    if (imageToSave == undefined) {
      this.addFiles(
        image,
        fileInput.target.files[0],
        categorie_Code,
        "categorie",
        "",
        "creerFichier",
        "imagesCategories",
        ""
      );
      this.enregistrementTerminer = true;
    } else {
      this.generalService
        .rechercheTable(
          this.generalService.urlFiles + "&val=" + imageToSave.File_Id
        )
        .subscribe(
          (imgTosave) => {
            imgTosave.Files[0].File_Content =
              this.generalService.redimentionnerImage(image, width, height, 80);
            imgTosave.Files[0].File_Text = fileInput.target.files[0].name;
            this.generalService.enregisterTable(imgTosave).subscribe(
              (data) => {
                this.generalService.dialogSuccess("Image enregistrer", true);
                this.enregistrementTerminer = true;
              },
              () => {
                this.generalService.dialogSuccess(
                  "Image non enregistrer",
                  false
                );
                this.enregistrementTerminer = true;
              }
            );
          },
          () => {
            this.generalService.dialogSuccess("Image non enregistrer", false);
            this.enregistrementTerminer = true;
          }
        );
    }
  }
  getImageCategorie() {
    this.generalService
      .rechercheTable(
        this.generalService.urlListeFilesR2 +
        "imagesCategories" +
        "," +
        "categorie"
      )
      .subscribe((img) => {
        this.imageCategorie = img;

        if (this.isAllCategoriesIsLoated) this.enregistrementTerminer = true;

        //get ds image
        var compte = 0;
        for (let i = 0; i < img.length; i++) {
          if (
            img[i].File_Key.indexOf("280_580") > -1 ||
            img[i].File_Key.indexOf("1450_700") > -1 ||
            img[i].File_Key.indexOf("1300_500") > -1 ||
            img[i].File_Key.indexOf("580_580") > -1
          )
            this.generalService
              .rechercheTable(
                this.generalService.urlFiles + "&val=" + img[i].File_Id
              )
              .subscribe((imgContent) => {
                compte++;
                this.imageCategorie[i]["File_Content"] =
                  imgContent.Files[0].File_Content;
                if (this.isAllCategoriesIsLoated) this.fillImageCategorieIn();
                if (compte == img.length)
                  this.imageCategorieForUpdateIsLodet = true;
              });
          else compte++;
        }
      });
  }
}
